export default "__VITE_ASSET__BIx$D8FD__"